import _ from 'lodash';
import React from 'react';

import {connect} from 'react-redux';
import {reduxForm, Field} from 'redux-form';

import {sendAgreementReminder} from 'ducks/bookings';

import ErrorBlock from 'components/ErrorBlock';
import {CheckBoxField} from 'components/Fields';

import './styles.css';

const formSubmit = (values, dispatch, props) => {
  const {agreementId, signatures, getExtraActions} = props;

  const agreementUsers: Array<any> = [];

  /*
  We want to get all agreement users that has checked checkbox in the form:

  For example:
  values === {primaryTenant: true, guarantor: false, agent: true}
  <id for primary tenant> === 1
  <id for agent> === 2
  <id for agent> === 3

  `agreementUsers` should be equal to [1, 3]
  */
  signatures.forEach(signature => {
    const {agreementRole, agreementUser} = signature;
    const fieldName = _.camelCase(agreementRole);

    if (values[fieldName] === true) {
      agreementUsers.push(agreementUser.id);
    }
  });

  const data = {
    agreementUsers,
    agreement: agreementId
  };

  dispatch(sendAgreementReminder(data, getExtraActions()));
};

const SendAgreementReminderForm = ({signatures, error}) => (
  <form className="SendAgreementReminderForm">
    {error && <ErrorBlock>{error}</ErrorBlock>}

    {signatures.map(signature => (
      <div className="signerUserRow" key={signature.id}>
        <div className="fullName"> {signature.agreementUser.fullName} </div>
        <div className="agreementRole">{signature.agreementRoleLabel}</div>
        <div className="email">{signature.agreementUser.email}</div>
        <Field
          className="signerUserCheckBox"
          name={_.camelCase(signature.agreementRole)}
          component={CheckBoxField}
          disabled={signature.isSigned}
        />
      </div>
    ))}
  </form>
);

const mapStateToProps = (_state, {signatures}) => {
  const agreementRoles = signatures.map(signature => signature.agreementRole);
  const fieldNames = agreementRoles.map(_.camelCase);
  const initialValues = {};

  fieldNames.forEach(fieldName => {
    initialValues[fieldName] = false;
  });

  return {initialValues};
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'sendAgreementReminder',
    onSubmit: formSubmit
  })(SendAgreementReminderForm)
);
